import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services SAP">
                            <h2>Full-Stack Services SAP - Consultancy To Implementation</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>Our services SAP domain aims to help startups and organizations yield powerful business
                            benefits of SAP implementation. We cover 360-degree SAP implementation use cases suiting
                            business requirements, journeys, challenges, and future goals.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;